import type {ReactNode} from 'react'
import {Animate} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import {useDitherBackground} from '../../hooks/useDitherBackground'
import type {AssetItemPosition} from '../../types'
import styles from './FlexSuiteHeroCarousel.module.css'
import mediaStyles from './HeroMediaFrame.module.css'

export function HeroCarouselMediaFrame({
  children,
  isActive,
  imagePosition,
}: {
  children: ReactNode
  isActive: boolean
  imagePosition?: AssetItemPosition
}) {
  const treated = imagePosition !== 'full-bleed'
  const {containerRef, DitherBackground} = useDitherBackground({
    className: styles.Dither,
    enabled: isActive && treated,
  })

  return (
    <div ref={containerRef} className={styles.ImageFrame} data-image-position={imagePosition}>
      <DitherBackground />
      <Animate animate="slide-in-up" className={styles.MediaAnimation}>
        <div className={clsx(styles.Media, treated && mediaStyles.GlassBorder)}>{children}</div>
      </Animate>
    </div>
  )
}
